import { graphql } from 'react-relay';

/**
 * The listings crawl-run history (pv-frontend#163), newest first — both
 * operator-triggered and nightly runs, with trigger, status and the stored rollup
 * totals. Excludes the per-agent breakdown; the drill-in reads that via
 * `crawlRunQuery`.
 *
 * Lives in `relay/` (not a screen) so the `graphql` tag is confined to modules
 * that go through the Babel transform — screens stay transform-free and testable.
 */
export const crawlRunsQuery = graphql`
    query crawlRunsQuery {
        crawlRuns {
            id
            trigger
            requestedByOperator
            scope
            siteId
            status
            requestedUtc
            startedUtc
            completedUtc
            sitesCrawled
            sitesPartiallyCrawled
            listingsAdded
            listingsUpdated
            listingsUnchanged
            listingsMissed
            listingsDelisted
            rejectsQueued
        }
    }
`;
